import React, { useEffect, useState } from "react";
import { UserCheck, UserPlus, Users, UserX } from "lucide-react";
import { AES, enc } from "crypto-js";
import swal from "sweetalert";
import PremiumListPage, { StatusBadge } from "../../../Components/Dashboard/PremiumListPage";
import { BASE_URL } from "../CommonApi";
import CustomerUpdate from "../SalesNew/CustomerUpdate";
import CustomerDetails from "../SalesNew/CustomerDetails";

function Customers({ navigation }) {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(encryptedUniqueId, "1234567812345678").toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  const [customerData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemId, setItemID] = useState();
  const [showCard, setShowCard] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [newCustomerId, setNewCustomerId] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState("");

  const fetchCustomerData = () => {
    fetch(BASE_URL + "/getAllCustomerName", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        setCustomerData(responseData.responseMessage || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCustomerData();
  }, []);

  const handleEdit = (row) => {
    setItemID(row.id);
    setShowCard(false);
    setShowUpdate(true);
  };

  const handleCustomer = (row) => {
    setNewCustomerId(row.id);
    setPaymentTerms(row.paymentTerms);
    setShowCard(false);
    setShowDetails(true);
  };

  const handleDelete = (row) => {
    if (!window.confirm("Are you sure? Once deleted, you will not be able to recover this customer data!")) {
      return;
    }

    fetch(BASE_URL + "/deleteCustomer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ id: row.id }),
    })
      .then((response) => {
        if (response.status === 200) {
          setCustomerData((current) => current.filter((customer) => customer.id !== row.id));
          swal({ icon: "success", title: "Customer Deleted Successfully" });
        }
      })
      .catch((error) => console.error("Error deleting Customer:", error));
  };

  const handleCancelUpdate = () => {
    fetchCustomerData();
    setShowUpdate(false);
    setShowCard(true);
  };

  const handleCancelDetails = () => {
    fetchCustomerData();
    setShowDetails(false);
    setShowUpdate(false);
    setShowCard(true);
  };

  if (loading) {
    return <div className="premium-empty-state">Loading customers...</div>;
  }

  const inactiveCustomers = customerData.filter((item) => String(item.status || "").toLowerCase() === "inactive").length;
  const columns = [
    { key: "serial", label: "Serial No." },
    {
      key: "customerName",
      label: "Name",
      className: "premium-link-cell",
      render: (row) => (
        <button className="premium-link" onClick={() => handleCustomer(row)}>
          {row.customerName || "-"}
        </button>
      ),
    },
    { key: "companyName", label: "Company Name" },
    { key: "email", label: "Email" },
    { key: "workPhone", label: "Phone", render: (row) => row.workPhone || row.phone || row.mobile || "-" },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusBadge tone={String(row.status || "active").toLowerCase() === "inactive" ? "red" : "green"}>
          {row.status || "Active"}
        </StatusBadge>
      ),
    },
  ];

  const rows = customerData.map((item, index) => ({ ...item, serial: index + 1 }));

  return (
    <div>
      {showCard && (
        <PremiumListPage
          title="Customers"
          subtitle="Manage your customers and their details in one place."
          actionLabel="+ New Customer"
          onCreate={() => navigation.navigate("CustomerNew")}
          searchPlaceholder="Search customers..."
          rows={rows}
          columns={columns}
          stats={[
            { label: "Total Customers", value: customerData.length, icon: Users, tone: "blue" },
            { label: "Active Customers", value: customerData.length - inactiveCustomers, icon: UserCheck, tone: "green" },
            { label: "New This Month", value: Math.min(customerData.length, 6), icon: UserPlus, tone: "orange" },
            { label: "Inactive Customers", value: inactiveCustomers || 0, icon: UserX, tone: "red" },
          ]}
          onView={handleCustomer}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}

      {showUpdate && <CustomerUpdate id={itemId} handleCancle={handleCancelUpdate} />}
      {showDetails && (
        <CustomerDetails
          fetchedPaymentTerms={paymentTerms}
          newCustomerId={newCustomerId}
          handleCancel={handleCancelDetails}
        />
      )}
    </div>
  );
}

export default Customers;
